const c = {
  name: "Feedback",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M33,17.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5C32.3,16,33,16.7,33,17.5z"/>
<path class="st0" d="M24,28c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4h2c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6H24z"/>
<path class="st0" d="M10,8.5C10,9.3,9.3,10,8.5,10S7,9.3,7,8.5S7.7,7,8.5,7S10,7.7,10,8.5z"/>
<path class="st0" d="M17,8.5c0,0.8-0.7,1.5-1.5,1.5S14,9.3,14,8.5S14.7,7,15.5,7S17,7.7,17,8.5z"/>
<path class="st0" d="M8,13c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4h2c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6H8z"/>
<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v18c0,1.7,1.3,3,3,3h1v6l6.4-6H16v7c0,1.7,1.3,3,3,3h10.6l6.4,6v-6h1c1.7,0,3-1.3,3-3V13
	c0-1.7-1.3-3-3-3H24V3c0-1.7-1.3-3-3-3H3z M24,12h13c0.5,0,1,0.5,1,1v18c0,0.5-0.5,1-1,1h-3v3.4L30.4,32H19c-0.5,0-1-0.5-1-1v-7h3
	c1.7,0,3-1.3,3-3v-2.1c0.2,0.1,0.3,0.1,0.5,0.1c0.8,0,1.5-0.7,1.5-1.5S25.3,16,24.5,16c-0.2,0-0.3,0-0.5,0.1V12z M2,3
	c0-0.5,0.5-1,1-1h18c0.5,0,1,0.5,1,1v18c0,0.5-0.5,1-1,1H9.6L6,25.4V22H3c-0.5,0-1-0.5-1-1V3z"/>
</svg>
  `
};
export {
  c as Feedback
};
